export enum UpfrontPaymentMethod {
  CreditCard = 1,
  EFT = 2,
  Cheque = 3,
  AgencyProcessed,
  BPAY,
  FatZebra
}
